import { log } from '@intigral/utils';

/**
 * Extracts the operating system and version from the user agent string.
 * @param userAgent - The user agent string.
 * @returns A tuple containing the operating system and version.
 */
export const getOS = (userAgent: string): [string, number] => {
    try {
        const operatingSystemRegex = /(Windows NT|Mac OS X|Linux|Android|iPhone OS|iPod|iPad|CPU OS) ([\d._]+)/;
        const operatingSystemMatch = userAgent.match(operatingSystemRegex);
        if (operatingSystemMatch && operatingSystemMatch[1] && operatingSystemMatch[2]) {
            let os = operatingSystemMatch[1].toLocaleLowerCase().split(' ')[0];
            /* eslint-disable no-useless-escape */
            const version = Number(operatingSystemMatch[2].replace(/\_/g, '.').split('.')[0]);
            /* eslint-enable no-useless-escape */
            if (os === 'cpu' || os === 'ipad') {
                os = 'iphone';
            }
            return [os, version];
        }
    } catch {
        log.error('Failed to extract OS version from user agent', userAgent);
    }

    return ['UNKNOWN', 0];
};
